// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"641af604","390":"641af604","490":"de8b387e","531":"d120dfe7"}[chunkId] + ".chunk.css";
};